window.addEventListener("load", function () {
    $("body").click(function () {
        if ($(".country_switch").hasClass("open")) {
            $(".country_switch").removeClass("open");
        }
    });

    $(".country_switch").click(function (e) {
        e.stopPropagation();
    });

    $(".country_switch_select").click(function (e) {
        e.stopPropagation();
        let parent = $(this).parent();
        if (parent.hasClass("open")) {
            parent.removeClass("open");
        } else {
            $(".country_switch").removeClass("open"); // 关闭其他已展开的菜单
            parent.addClass("open");
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  $(".custom_gift_bundling").on("change", function () {
    let selectedValues = [];

    $(".custom_gift_bundling:checked").each(function () {
      selectedValues.push($(this).val());
    });

    let html = "";
    selectedValues.forEach(function (variantId, index) {
      html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
    });

    $(".custom_free_bundling_wrapper").html(html);
  });

  $(".custom_gift_bundling").first().trigger("change");
});

function toggleShowed() {
  var bundlesText = document.querySelector(".product-discount-shower-bundling");
  var bundlesbtnstext = document.querySelector(".product-bundles-btns-text");
  var BundlesDown = document.querySelector(".BundlesDown-icon");

  if (bundlesText.classList.contains("expanded")) {
    bundlesText.classList.remove("expanded");
    bundlesbtnstext.textContent = "Show more";
    BundlesDown.classList.remove("up");
  } else {
    bundlesText.classList.add("expanded");
    bundlesbtnstext.textContent = "Show less";
    BundlesDown.classList.add("up");
  }
}